<fa-icon [icon]="iconCart" size="lg" (click)="openCheckout()"></fa-icon>
@if (this.list >= 1) {
  <div class="count"></div>
}
